import * as C from '@/consts'
import * as a from '@/libs/a'
import logo from '@/assets/card-brands/diners-logomark-img-01.gif'

export default {
  // ブランドコード
  code: C.BRAND_DINERS,

  // ブランド判定
  match (number) {
    // 300 - 303574, 3095, 36, 38 - 39
    const prefix = (number + '000000').slice(0, 6) | 0

    const result =
      a.between(prefix, 300000, 303574) ||
      a.between(prefix, 309500, 309599) ||
      a.between(prefix, 360000, 369999) ||
      a.between(prefix, 380000, 399999) ||
      false
    return result
  },

  // カード番号のパターン
  pattern: [4, 6, 4],

  // ロゴ
  logo
}
